import apiClient from './authService';

export const verificationService = {
  async verifyDocument(code) {
    try {
      const response = await apiClient.get(`/verify?code=${code}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Verification failed');
    }
  },

  async downloadOriginal(code) {
    try {
      const response = await apiClient.get(`/verify/${code}/download/original`, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to download original document');
    }
  },

  async downloadQRProtected(code) {
    try {
      const response = await apiClient.get(`/verify/${code}/download/qr-protected`, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to download QR-protected document');
    }
  },

  async getVerificationStats(days = 30) {
    try {
      const response = await apiClient.get(`/verify/stats?days=${days}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch verification statistics');
    }
  },
};